<template>
  <div>
    <!-- 表头 -->
    <van-sticky offset-top="1.0558rem">
      <div class="boxTitle">
        <van-row type="flex" justify="center" align="center">
          <van-col span="2" align="center">序号</van-col>
          <van-col span="7" align="center">商品</van-col>
          <van-col span="8" align="center">本期价格</van-col>
          <van-col span="4" align="center">上期价格</van-col>
          <van-col span="3" align="center">环比%</van-col>
        </van-row>
      </div>
    </van-sticky>

    <div class="table">
      <van-list v-model="loading" :finished="finished" finished-text="" @load="onLoad" style="padding-bottom: 1.2rem">
        <div :class="[index % 2 == 0 ? 'even' : 'odd']" v-for="(item, index) in list" :key="index">
          <van-row type="flex" justify="center" align="center">
            <!-- 第一列 -->
            <van-col span="2" align="center">
              <div style="width: 50%; background-color: red; color: #fff" v-if="!item.isGoods && handComputeIfshow(item)">
                {{ index + 1 }}
              </div>
              <div v-else-if="item.isGoods || !item.list">
                {{ index + 1 }}
              </div>
              <div v-else style="width: 50%; background-color: green; color: #fff">
                {{ index + 1 }}
              </div>
            </van-col>
            <!-- 第二列 -->
            <van-col
              span="7"
              :style="{
                color: computeNeed.includes(item.VarietyCode)
                  ? '#000000'
                  : item.VarietyCodeNew == item.VarietyCode ||
                    item.isGoods == 1 ||
                    (item.ThisPrice == 0 && item.ThisPrice !== '' && item.dataType !== '1003') ||
                    (item.importInfo == 0 && item.importInfo !== '' && item.dataType == '1003') ||
                    (item.hbzks !== null && item.hbNum >= item.hbzks && item.hbNum > 0) ||
                    (item.hbjks !== null && Math.abs(item.hbNum) >= item.hbjks && item.hbNum < 0) ||
                    (item.dqbb &&
                      parseFloat(item.sameNumPrice) == parseFloat(item.ThisPrice) &&
                      item.sameNum + (parseFloat(item.sameNumPrice) == parseFloat(item.ThisPrice) ? 1 : 0) >= item.dqbb)
                  ? 'red'
                  : 'blue'
              }"
              class="contentLimit"
              @click="clickStoreName(item, index)"
            >
              {{ item.VarietyName }}--{{ item.StandardName }}--{{ item.TargetName }}
            </van-col>
            <van-col span="1" align="center">&emsp;</van-col>
            <!-- 第三列 -->
            <van-col span="8">
              <div class="input">
                <!-- 字符 -->
                <input
                  v-model="item.importInfo"
                  :class="{ bianhui: saveState || item.isGoods == 1 }"
                  :style="{
                    background: (item.importInfo == 0 && item.importInfo !== '') || saveState || item.isGoods == 1 ? '#efe7e7' : ''
                  }"
                  required
                  @click="clickStoreName(item, index)"
                  v-if="item.dataType == '1003'"
                />
                <!-- 数字 -->
                <input
                  v-model="item.ThisPrice"
                  :class="{ bianhui: saveState || item.isGoods == 1 || computeNeed.includes(item.VarietyCode) }"
                  @blur="changePrice(item, index)"
                  type="number"
                  :style="{
                    background:
                      (item.ThisPrice == 0 && item.ThisPrice !== '') || saveState || item.isGoods == 1 || computeNeed.includes(item.VarietyCode)
                        ? '#efe7e7'
                        : ''
                  }"
                  oninput="if(value<0)value=0; if(value>99999999999999)value=99999999999999"
                  :min="item.goods_minimum || 0"
                  :max="item.goods_maximum || 99999999999999"
                  required
                  v-else
                />
              </div>
              {{ item.UnitName }}
            </van-col>
            <!-- 第四列 -->
            <van-col span="2" align="right" class="list-ringPrice">{{ item.ringPrice }}</van-col>
            <!-- 环比：（本期数-上期数）/上期数×100% -->
            <!-- 第五列 -->
            <van-col span="3" align="right" :style="{ color: item.styleColor }" v-model="item.hbNum">{{ item.hbNum }}</van-col>
            <van-col span="1" align="right">&emsp;</van-col>
          </van-row>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import { calculateComputeInfoChange } from '@/utils/formulaCalculation.js';
import { Toast } from 'vant';
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
    saveState: {
      type: Boolean,
      default: false
    },
    computeSetList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    computeNeed: {
      type: Array,
      default: () => {
        return [];
      }
    },
    goodsInfosNeed: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      loading: false,
      finished: false
    };
  },
  methods: {
    onLoad() {
      setTimeout(() => {
        this.loading = false;
        this.finished = true;
      }, 1000);
    },
    // 判断是否显示红色序号------有必填的拓展字段未填
    handComputeIfshow(row) {
      let ifShow = false;
      if (!row.list) {
        return false;
      }
      row.list.forEach((i) => {
        if ((row[i.fieldName] == '' || !row[i.fieldName]) && i.ifMust == 1) {
          return (ifShow = true);
        }
      });
      return ifShow;
    },
    // 点击商品显示弹框
    clickStoreName(item, index) {
      if (!this.computeNeed.includes(item.VarietyCode)) {
        this.$emit('handItemCLick', item, index);
      } else {
        Toast('该商品为系统计算结果！');
      }
    },
    //环比实时变化
    changePrice(item, i) {
      if (!item) {
        item = this.list[i];
      }
      let hbNum;
      let ringPrice = this.list[i].ringPrice; //上期 ringPrice
      let thisPrice = this.list[i].ThisPrice; //本期 ThisPrice
      //report_digits
      calculateComputeInfoChange(this, this.list, item);
      if (!Number(thisPrice) || thisPrice == '') {
        this.list[i].hbNum = '-';
        return;
      }
      if (thisPrice.split('.').length - 1 > 1) {
        Toast('本期价格输入格式不正确请重新输入!');
        return;
      }
      thisPrice = parseFloat(thisPrice).toFixed(this.list[i].report_digits);
      this.list[i].ThisPrice = thisPrice;
      if (!Number(ringPrice) || ringPrice == 0) {
        this.list[i].hbNum = '-';
        return;
      }
      ringPrice = parseFloat(ringPrice);
      thisPrice = parseFloat(thisPrice);
      hbNum = ((thisPrice - ringPrice) / ringPrice) * 100;
      if (hbNum == Infinity || isNaN(hbNum)) {
        this.list[i].hbNum = '-';
      } else {
        if (hbNum > 0) {
          this.list[i].styleColor = 'red';
        } else if (hbNum < 0) {
          this.list[i].styleColor = 'green';
        } else {
          this.list[i].styleColor = 'black';
        }
        if (hbNum.toString().indexOf('.') != -1 && hbNum.toString().split('.')[1].length > 2) {
          hbNum = hbNum.toFixed(2);
        }
        this.list[i].hbNum = hbNum;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.boxTitle {
  height: 1rem;
  line-height: 1rem;
  background-color: #4494f3;
  color: #ffffff;
  font-size: px2rem(36);
}
.table {
  height: calc(100% - 5.7158rem);
  .input {
    display: inline-block;
    vertical-align: middle;
    width: 1.3rem;
    background-color: #fff;
    border: px2rem(1) solid #4494f3;
    input {
      margin: 0;
      border: 0;
      height: 0.8rem;
      vertical-align: middle;
      width: 1.3rem;
      outline: none;
      text-align: left;
    }
  }
  .even {
    display: flex;
    font-size: px2rem(36);
    background-color: #f2fbfe;
    color: #3e3e3e;
    /deep/.van-row {
      width: 100vw;
      height: 50px;
    }
  }
  .odd {
    display: flex;
    font-size: px2rem(36);
    background-color: #e0f7ff;
    color: #3e3e3e;
    /deep/.van-row {
      width: 100vw;
      height: 50px;
    }
  }
  .list-ringPrice {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .contentLimit {
    //表格内容商品列限制三行展示
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  //审核过的事项 底部按钮变灰
  .bianhui {
    pointer-events: none;
    filter: grayscale(1);
    .btn1 {
      font-weight: 400;
      color: #ababab;
    }
  }
}
</style>
